import { useEffect, useState } from "react";
import { Bookmark, X } from "lucide-react";

// Format a timestamp relative to now in Portuguese ("agora mesmo", "há 2min",
// "há 1h", "há 3d"). Designed to match the casual tone of a draft indicator —
// no precise dates, only a rough time-of-last-save signal.
const formatRelative = (ts) => {
  if (!ts) return "";
  const diffMs = Date.now() - ts;
  const sec = Math.max(0, Math.floor(diffMs / 1000));
  if (sec < 30) return "agora mesmo";
  if (sec < 60) return `há ${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `há ${min}min`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `há ${hours}h`;
  const days = Math.floor(hours / 24);
  return `há ${days}d`;
};

export const DraftIndicator = ({ savedAt, hasDraft, onClear }) => {
  // Re-render periodically so the "há Xmin" label stays fresh. The interval is
  // anchored to savedAt (not mount time) so that the first tick aligns with the
  // 30s threshold instead of firing 100-300ms too early. 10s cadence keeps the
  // label snappy without measurable CPU cost on a single small component.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!hasDraft || !savedAt) return;
    const id = setInterval(() => setTick((t) => t + 1), 10000);
    return () => clearInterval(id);
  }, [hasDraft, savedAt]);

  if (!hasDraft || !savedAt) return null;

  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 border border-slate-200 text-xs text-slate-700"
      data-testid="draft-indicator"
    >
      <Bookmark className="w-3.5 h-3.5 text-[var(--brand-primary)]" />
      <span>Rascunho guardado · <span className="font-medium" data-testid="draft-saved-at">{formatRelative(savedAt)}</span></span>
      {onClear && (
        <button
          type="button"
          onClick={onClear}
          className="ml-1 flex items-center gap-0.5 text-slate-500 hover:text-red-600 transition-colors"
          title="Limpar rascunho"
          data-testid="draft-clear-btn"
        >
          <X className="w-3 h-3" />
          Limpar
        </button>
      )}
    </div>
  );
};
